import FriendsServiceDB from './friendsServiceDB';
import { discoveryCohorts } from '../utils/whatsOnDiscovery';

/** Fetch primary independently so farther rows cannot displace it at the SQL
 * gate. The caller checks its composed target (after follow/dismissal dedupe)
 * before asking for fallback. No trip widening: ranked discovery is local to
 * the active center; the separate follow calendar owns artist trip eligibility.
 */
export async function getDiscoveryCohort({ center, farther = false, ...params }) {
  const discoveryBand = center.kind === 'none' ? 'global' : farther ? 'farther' : 'primary';
  const result = await FriendsServiceDB.getFeed({
    ...params, contentType: 'events', sort: 'ranked', discoveryBand,
    lat: center.lat, lng: center.lng
  });
  const pools = discoveryCohorts(result.feed || [], center);
  return { ...result, feed: pools[discoveryBand], candidateCount: (result.feed || []).length };
}

/** Exhaust eligible primary pages before considering the outer cohort. Count
 * what composition can actually render, not raw rows: follows and dismissals
 * may own most of a page. Surface targets and per-request limits stay intact.
 */
export async function getDiscoverySelection({ center, target, countVisible, ...params }) {
  const primary = [], farther = [];
  const counts = { primaryFetched: 0, primaryEligible: 0, fartherFetched: 0, fartherEligible: 0 };
  for (const isFarther of [false, true]) {
    if (isFarther && (center.kind === 'none' || countVisible(primary, farther) >= target)) break;
    let cursor;
    const cursors = new Set();
    do {
      const result = await getDiscoveryCohort({ ...params, center, farther: isFarther, cursor });
      if (result.error) return { primary, farther, counts, error: result.error };
      const pool = isFarther ? farther : primary;
      pool.push(...result.feed);
      counts[isFarther ? 'fartherFetched' : 'primaryFetched'] += result.candidateCount;
      counts[isFarther ? 'fartherEligible' : 'primaryEligible'] += result.feed.length;
      if (countVisible(primary, farther) >= target || !result.hasMore || !result.cursor || cursors.has(result.cursor)) break;
      cursor = result.cursor;
      cursors.add(cursor);
    } while (cursor);
  }
  return { primary, farther, counts };
}
